import { render, staticRenderFns } from "./EditOrganizationFunctions.vue?vue&type=template&id=0c388b2b&scoped=true"
import script from "./EditOrganizationFunctions.vue?vue&type=script&lang=js"
export * from "./EditOrganizationFunctions.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationFunctions.vue?vue&type=style&index=0&id=0c388b2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c388b2b",
  null
  
)

export default component.exports